
import {
  mall_orders_create
} from "@/api/goods-api";

import qs from "qs";

import { Toast } from "vant";

var XIZHANG_createOrder = function () {
  Toast({ message: "正在创建订单" })

  var orderInfo = sessionStorage.getItem("rc-25-order_info")

  var order = JSON.parse(orderInfo).content
  order.goodsList.forEach(e => {
    e.goodsCount = e.count
    e.goodsId = e.goods.goodsId
  })

  budo_log.info("#21 XIZHANG_createOrder, order=", order)

  // 西藏的支付 没有卡券
  order.cardList = []

  var params = qs.parse(location.search.replace(/^\?/, ''))
  order.goodsType = params.goodsType
  order.timeId = new Date().getTime()

  return new Promise(function (resolve) {
    mall_orders_create(order).then(resolve)
  })
}

const XIZHANG_SEPARATOR = "_-^-_";

const ORDER_INFO_CACHE_KEY = "cache-order-info-2025" // cache-orderInfo-20231220-2

export {
  XIZHANG_SEPARATOR,
  XIZHANG_createOrder,
  ORDER_INFO_CACHE_KEY
}

// import { ORDER_INFO_CACHE_KEY } from "@/util/XiZhangUtil"